export default "__VITE_ASSET__A43S71w4__"